import { marketplacesEnum } from "@/v2/utils/marketplaces";

export const channelTypes = Object.freeze({
	WhatsApp: 'whatsapp',
	WhatsAppQR: 'whatsapp-qr',
	Instagram: 'instagram',
	Messenger: 'messenger',
});

export const chanelMarketplace = Object.freeze({
	[channelTypes.WhatsApp]: marketplacesEnum.WhatsApp,
	[channelTypes.WhatsAppQR]: marketplacesEnum.WhatsAppQR,
	[channelTypes.Instagram]: marketplacesEnum.Instagram,
	[channelTypes.Messenger]: marketplacesEnum.Messenger,
});

